/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Split_EventInputs */



/**
* | output |
* | --- |
* | "Split the selected event based on the cursor location" |
*
* @param {Shortcut_Keys_Desc_Split_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_split_event = /** @type {((inputs?: Shortcut_Keys_Desc_Split_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Split_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Diviser l'evenement selectionne selon la position du curseur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Teilen Sie das ausgewählte Ereignis anhand der Cursorposition auf.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dividi l'evento selezionato in base alla posizione del cursore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Разделите выбранное событие в зависимости от положения курсора.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Dividir el evento seleccionado según la ubicación del cursor")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("根据光标位置拆分选定的事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("カーソル位置に基づいて選択したイベントを分割します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कर्सर की स्थिति के आधार पर चयनित इवेंट को विभाजित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Divida o evento selecionado com base na localização do cursor.")
	return /** @type {LocalizedString} */ ("Split the selected event based on the cursor location")
});